import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { ChangeEmailConfirmPage } from 'src/pages/change-email';
import type { RouteProps } from 'src/types/router';

export const EMAIL_CHANGE_ROUTE: RouteProps = {
  path: appRoutes.emailChangeRequest.index,
  element: <ChangeEmailConfirmPage />,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
